<button
  class="px-2 me-2"
  kendoButton
  [fillMode]="!enableHoldButton() ? 'outline' : 'solid'"
  rounded="large"
  themeColor="primary"
  [title]="
    _clientWO.bulkActionsDisabled()
      ? ('HOME.STREAM.DISABLED_TOOLTIP'
        | translate: { count: (_clientWO.loadedRowCount() | number) })
      : ('HOME_COMPONENTS.HOLD.HOLD' | translate)
  "
  [disabled]="!enableHoldButton() || _clientWO.bulkActionsDisabled()"
  (click)="showHoldPopup = true; holding = true"
  >
  <fa-icon [icon]="faPause" class="w-px-20 me-1"></fa-icon>
  {{ 'HOME_COMPONENTS.HOLD.HOLD' | translate }}
</button>

@if (showHoldPopup) {
  <kendo-dialog (close)="showHoldPopup = false">
    <kendo-dialog-titlebar class="text-primary">{{ 'HOME_COMPONENTS.HOLD.HOLD' | translate }}</kendo-dialog-titlebar>
    <div class="p-3">
      <div class="mb-3">
        {{ 'HOME_COMPONENTS.HOLD.CONFIRM_TEXT' | translate }}
      </div>
      @if (rHold2.checked && woInBlackOut) {
        <div
          class="dialog-warning text-center small"
          >
          <div>{{ 'HOME_COMPONENTS.HOLD.BLACKOUT_SELECTED' | translate }}</div>
          <div>{{ 'HOME_COMPONENTS.HOLD.RELEASE_HOLD_QUESTION' | translate }}</div>
        </div>
      }
      <div class="choice-title">{{ 'HOME_COMPONENTS.HOLD.ACTION' | translate }}</div>
      <div>
        <input
          class=""
          kendoRadioButton
          type="radio"
          #rHold1
          id="rHold1"
          name="rgHold"
          (click)="onHold(true)"
          checked
          />
        <label class="k-radio-label" for="rHold1">{{ 'HOME_COMPONENTS.HOLD.SET_ON_HOLD_STATUS' | translate }}</label><br />
        <input
          class=""
          kendoRadioButton
          type="radio"
          #rHold2
          id="rHold2"
          name="rgHold"
          (click)="onHold(false)"
          />
        <label class="k-radio-label" for="rHold2">{{ 'HOME_COMPONENTS.HOLD.RELEASE_HOLD_STATUS' | translate }}</label
          ><br />
        </div>
      </div>
      <kendo-dialog-actions [layout]="'end'">
        <button kendoButton look="outline" (click)="showHoldPopup = false">
          {{ 'HOME_COMPONENTS.COMMON.NO' | translate }}
        </button>
        <button kendoButton [themeColor]="'primary'" (click)="onSave()">{{ 'HOME_COMPONENTS.COMMON.YES' | translate }}</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  }
